import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import style from "../styles/components/navbar.module.scss";
import Image from "next/image";
import Link from "next/link";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState<string | null>(null);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const scrollToSection = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setIsMenuOpen(false);
      setActiveLink(id);
    }
  };

  useEffect(() => {
    if (!activeLink) return;

    const timer = setTimeout(() => {
      setActiveLink(null);
    }, 5000);

    return () => clearTimeout(timer);
  }, [activeLink]);

  const navItems = [
    { id: "sobre", label: "Sobre mim" },
    { id: "servicos", label: "Serviços" },
    { id: "missao-valores-visao", label: "Missão" },
    { id: "avaliacoes", label: "Avaliações" },
    { id: "perguntas", label: "Perguntas frequentes" },
    { id: "contato", label: "Contato" },
  ];

  return (
    <nav className={style.navbar} aria-label="Menu principal">
      <div className={style.container}>
        <Link href="/" aria-label="Página inicial" className={style.logo}>
          <Image
            src="/assets/horizontal-logo.webp"
            alt="Ícone Renata Oliveira Advocacia"
            width={400}
            height={80}
            style={{ objectFit: "contain" }}
            priority
          />
        </Link>

        <ul className={style.navLinks}>
          {navItems.map(({ id, label }) => (
            <li key={id}>
              <a
                href={`#${id}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(id);
                }}
                className={activeLink === id ? style.active : ""}
              >
                {label}
              </a>
            </li>
          ))}
        </ul>

        <button
          className={style.menuToggle}
          onClick={toggleMenu}
          aria-expanded={isMenuOpen}
          aria-controls="menu-principal"
          aria-label={isMenuOpen ? "Fechar menu" : "Abrir menu"}
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {isMenuOpen && (
        <div
          id="mobile-menu"
          className={style.mobileMenu}
          role="dialog"
          aria-modal="true"
        >
          <div className={style.mobileMenuContent}>
            {navItems.map(({ id, label }) => (
              <button
                key={id}
                onClick={() => scrollToSection(id)}
                className={`${style.mobileMenuItem} ${
                  activeLink === id ? style.active : ""
                }`}
              >
                {label}
              </button>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
